import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import "./index.less";
import { Resource } from "@/types/resource";
import { getResourceDownloadUrl } from "@/api/freeDownload";
import { download } from "@/pages/Message/MessageDetail/download";
import { Popover } from "antd";
import { isOwnProperty } from "@/utils/common";
import CommonCheckbox from "@/components/Checkbox";
import DesPopover from "./desPopover";
import DownloadPopover from "./downloadPopover";
import { SelectContext } from "../ResourceDetail/card";

interface DownloadCardProps {
  data: Resource.ResourceDetail[];
  downloadHandle: (id: string) => void;
}

interface DownloadListItemProps {
  onClickHandle: (data: Resource.ResourceDetail) => void;
  data: Resource.ResourceDetail;
}

const prefix = "download-list";

const DownloadListItem = (props: DownloadListItemProps) => {
  const { data, onClickHandle } = props;
  const { isDownloadAll, changeSelect } = useContext(SelectContext);
  // console.log("DownloadListItem", data, isDownloadAll);
  const isSkuList = isOwnProperty(data, "skuList") && Array.isArray(data.skuList) && data.skuList.length > 0;
  const btnName = data.urlType == Resource.ResourceUrlType.DOWNLOAD ? "下载" : "点击跳转";
  const timeRef = useRef<any>(null);
  const onDownloadClickHandle = useCallback((params:any) => {
    if(timeRef.current!=null) return;
    console.log("onDownloadClickHandle", params);
      timeRef.current = setTimeout(() => {
        onClickHandle(params);
        timeRef.current = null;
      }, 500);
  }, []);
  const downloadListClickHandle = (type: string, value: any) => {
    console.log("downloadListClickHandle", value, data,type);
    if (type == "select") {
      changeSelect(value);
    }
    if (type == "download") {
      onDownloadClickHandle({ ...value, urlType: data.urlType, ifHasUrl: data.ifHasUrl, skuList: data.skuList || [] })
    }
  };
  useEffect(()=>{
    return ()=>{
      timeRef.current=null;
    }
  })
  return (
    <div className={`${prefix}`} key={data.id}>
      <div className={`${prefix}-left`}>
        <div className={`${prefix}-left-title`}>
          {isDownloadAll && <CommonCheckbox checked={data?.isSelect} disabled={data.urlType == Resource.ResourceUrlType.LINK} onChange={(e) => changeSelect(data.id)} />}

          {isDownloadAll && isSkuList && (
            <DownloadPopover
              onClickHandle={downloadListClickHandle}
              list={data.skuList}
              type={"select"}
              popoverConfig={{
                arrow: false,
                placement: "bottomLeft",
              }}
            >
              <div className={`${prefix}-left-title-more`}></div>
            </DownloadPopover>
          )}

          {data.name}
        </div>
        <DesPopover detail={data} />
      </div>
      <div className={`${prefix}-right`}>
        {isSkuList ? (
          <DownloadPopover
            list={data.skuList}
            onClickHandle={downloadListClickHandle}
            popoverConfig={{
              arrow: false,
              placement: "bottomRight",
            }}
          >
            <div className="download-btn">
              <span>下载</span>
              <div className="download-btn-arrow">
                <div className="arrow"></div>
              </div>
            </div>
          </DownloadPopover>
        ) : (
          <div className="download-btn" onClick={onDownloadClickHandle.bind(this, data)}>
            <span>{btnName}</span>
            {data.urlType == Resource.ResourceUrlType.DOWNLOAD && (
              <div className="download-btn-arrow">
                <div className="arrow"></div>
              </div>
            )}
          </div>
        )}

        <div className={`resource-size flex-center`}>{data.resourceSize}</div>
      </div>
    </div>
  );
};

const DownloadList: React.FC<DownloadCardProps> = (props) => {
  const { data, downloadHandle } = props;
  // console.log("DownloadList render", data);

  const linkUrlHandle = useCallback(
    /**
     * 跳转其他链接
     * @param url
     */
    (url: string) => {
      window.open(url, "_blank");
    },
    []
  );

  const onClickHandle = (data: Resource.ResourceDetail) => {
    console.log("onClickHandle", data);
    const id = data.id.includes("-") ? data.id.split("-")[1] : data.id;
    if (data.urlType == Resource.ResourceUrlType.DOWNLOAD) {
      downloadHandle(id);
    } else {
      linkUrlHandle(data.resourceUrl);
    }
  };

  return (
    <div className="download-list-container">
      {data.map((detail: Resource.ResourceDetail, i: number) => {
        return <DownloadListItem data={detail} key={detail.id} onClickHandle={onClickHandle} />;
      })}
    </div>
  );
};

export default React.memo(DownloadList);
